import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "./store";
import { icons } from "@/components/Base/Lucide";

export interface Menu {
  icon: keyof typeof icons;
  title: string;
  badge?: number;
  pathname?: string;
  subMenu?: Menu[];
  ignore?: boolean;
}

export interface SideMenuState {
  menu: Array<Menu | string>;
  selectedUserId?: string;
}

const initialState: SideMenuState = {
  menu: [
    "MANAGE",
    {
      icon: "LayoutDashboard",
      pathname: "/app",
      title: "Dashboard",
    },
    {
      icon: "Boxes",
      pathname: "/app/inventory",
      title: "Inventory",
    },
    {
      icon: "ArrowLeftRight",
      pathname: "/app/stock-movements",
      title: "Stock Movements",
    },
    {
      icon: "Receipt",
      pathname: "/app/reimbursements",
      title: "Reimbursements",
    },
    {
      icon: "BadgePercent",
      pathname: "/app/rebates",
      title: "Rebates",
    },
  ],
  selectedUserId: undefined,
};

export const sideMenuSlice = createSlice({
  name: "sideMenu",
  initialState,
  reducers: {
    setCompanyId: (state, action) => {
      const companyId = action.payload;

      // Update the pathname for company-specific items
      state.menu = state.menu.map((item) => {
        if (typeof item !== "string") {
          // Reserved for future multi-company scoping (if needed).
          // For now, keep menu paths static for StockLedger.
        }
        return item;
      });
    },
    setUserId: (state, action) => {
      state.selectedUserId = action.payload;
    }
  },
});

export const { setCompanyId, setUserId } = sideMenuSlice.actions;

export const selectSideMenu = (state: RootState) => state.sideMenu.menu;

export default sideMenuSlice.reducer;

